import React from "react";
import { getWhatsappStateData } from "../../Action/courseAction";
import { WhatsappDataPage } from "../Common/whatsappCommon";

function WhatsappDataStateAnalysis() {
  return (
    <WhatsappDataPage
      pageTitle="WHATSAPP DATA STATE ANALYSIS"
      tableId="whatsapp-data-state-analysis"
      fetchAction={getWhatsappStateData}
      examKey="examId"
      nameKey="stateName"
      nameHeader="State"
      exportName="WhatsApp State Analysis"
    />
  );
}

export default WhatsappDataStateAnalysis;
